<template>
<div style="min-width: fit-content;" ref="tab" v-show="isActiveContent">
    <slot></slot>
</div>
</template>

<script>
import { tabBus } from '@/utils/tab-bus';

export default {
    props: {
        index: {
            type: String,
            required: true,
        },
    },
    data () {
        return {
            isActiveContent: false,
        };
    },
    mounted () {
        tabBus.$on('tab-change', this.updateActiveState);

        const rows = this.$refs.tab.querySelectorAll('.odr-row');
        rows.forEach(row => {
            row.style.setProperty('min-width', 'fit-content', 'important');
            row.style.setProperty('width', '100%', 'important');
        });
    },
    methods: {
        updateActiveState (activeIndex) {
            this.isActiveContent = this.index === activeIndex;
        },
    },
};
</script>
